import React, { Fragment, useEffect, useState } from 'react';
import TableCommon from '../../../../components/common/table/TableCommon';
import { useParams } from 'react-router-dom';
import * as CommonService from '../../../../services/CommonService';
import { PRODUCT_ENDPOINT } from '../../../../services/endpoint';
import { message } from 'antd';
import { dateToString, formatCurrency } from '../../../../utils';
import { PRODUCT_ACTION } from '../../../../utils/const';

const DEFAULT_PAGE = {
	currentPage: 1,
	perpage: 1000000
};

export default () => {

	const { id } = useParams();
	const [ds, setDs] = React.useState([]);
	const [loading, setLoading] = React.useState(false);
	const [searchValues, setSearchValues] = useState({});

	const [page, setPage] = useState({
		...DEFAULT_PAGE,
		total: 0
	});

	useEffect(() => {
		const init = async () => {
			try {
				setLoading(true);
				const resp = await CommonService.get(`${PRODUCT_ENDPOINT}/history/${id}`, {
					page: page.currentPage - 1,
					size: page.perpage
				});
				setDs(resp.data);
				setPage({ ...page, total: resp.data?.totalElements });
			} catch (error) {
				message.error(error?.data?.message || 'Có lỗi xảy ra');
			} finally {
				setLoading(false);
			}
		};
		init();
	}, []);

	const onSearch = async (pageParam = DEFAULT_PAGE) => {
		const param = { ...searchValues, page: pageParam.currentPage - 1, size: pageParam.perpage };
		window.setLoading(true);
		const resp = await CommonService.get(`${PRODUCT_ENDPOINT}/history/${id}`, param);
		setDs(resp.data);
		setPage({
			total: resp.data?.totalElements,
			...pageParam
		});
		window.setLoading(false);
	};

	const columns = [
		{
			title: 'STT',
			dataIndex: 'index',
			width: 60,
			align: 'center',
			render: (text, record, index) => (page.currentPage - 1) * page.perpage + index + 1
		},
		{
			title: 'Ngày ghi nhận',
			dataIndex: 'createdDate',
			width: 200,
			align: 'center',
			render: (text) => (<span>{dateToString(text)}</span>)
		},
		{
			title: 'Thao tác',
			dataIndex: 'action',
			width: 200,
			align: 'center',
			render: (text) => PRODUCT_ACTION.find(el => el.value == text)?.name || '-'
		},
		{
			title: 'Nhân viên',
			dataIndex: 'actionBy',
			width: 200,
			align: 'center'
		},
		{
			title: 'Số lượng thay đổi',
			dataIndex: 'quantity',
			width: 250,
			align: 'center',
			render: (value) => formatCurrency(value)
		},
		{
			title: 'Tồn kho',
			dataIndex: 'inventory',
			width: 110,
			align: 'center'
		},
		{
			title: 'Chi nhánh',
			dataIndex: 'branchName',
			width: 110,
			align: 'center'
		}
	];

	return (
		<Fragment>
			<TableCommon
				className={'max-height-500'}
				loading={loading}
				bordered={true}
				page={page}
				setPage={setPage}
				datasource={ds}
				columns={columns}
				onSearch={onSearch}
				pagination={false}
			/>
		</Fragment>);
}

